import React, { useContext } from 'react';
import classNames from 'classnames';
import { IOneImage } from './Common';
import LazyLoadColumn from './LazyLoadColumn';
import { ThemeContext } from '../../store/ThemeProvider';
import { getPendantColor } from '../../utils/color';
import StatusTag from '../Tag/StatusTag';
import { IGalleryStatus } from '../../global.d';
// 请在外层直接引用gallery-list样式

interface IColumn5 extends IOneImage {
  bgColor?: string;
}
const Column5 = (props: IColumn5) => {
  const { mainColor, componentColor, backgroundColor } = useContext(
    ThemeContext
  );
  const [bgColor] = getPendantColor(backgroundColor);

  return (
    <div className={'column column5'} onClick={props.onClick}>
      <LazyLoadColumn lazy={props.lazy}>
        <div
          className="img-wrapper"
          style={{
            background: `url(${props.src}) ${props.bgColor ||
              bgColor} center top / cover no-repeat`
            // backgroundSize: 'cover'
          }}
          data-index={
            props && typeof props.index != 'undefined'
              ? props.index * 1 + 1
              : 0
          }
        />
      </LazyLoadColumn>

      {props.children}
    </div>
  );
};

export default Column5;
